/**
 * Значки карточки занятия.
 *
 * Свои SVG прямо в коде, а не пакет иконок и тем более не шрифт с чужого
 * домена: при шатдауне с белым списком страница обязана отрисоваться целиком
 * (раздел 4 CLAUDE.md). Правила те же, что у значков сайдбара и материалов:
 * viewBox 24x24, `currentColor`, ни одного размера внутри. Размер и цвет
 * задаёт CSS.
 *
 * ⚠️ Значок здесь пустой для читалок (`aria-hidden`), а подпись живёт на
 * кнопке: `aria-label` плюс `title`. Иконка без подписи это ребус, и на
 * телефоне, где наведения нет вовсе, ребус остаётся неразгаданным.
 *
 * ⚠️ **Исключение из этого правила существует, но живёт не здесь.** Значок,
 * которым заменили СЛОВО (раздел 8б `docs/cabinet-tables-design.md`, вид
 * занятия в расписании), подписывается сам, потому что подписи рядом с ним нет
 * вовсе; объявлено это в `features/shell/icons.tsx`, где такие значки и лежат.
 * В этом файле значки только кнопочные, поэтому исключению здесь взяться
 * неоткуда, и заводить его тут не надо.
 */

function Svg(props: { children: React.ReactNode }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {props.children}
    </svg>
  );
}

/**
 * Перенести: календарь и стрелка вправо.
 *
 * Не двойная стрелка и не «часы»: занятие уезжает на другой ДЕНЬ чаще, чем на
 * другой час, и календарь в фигуре говорит именно это.
 */
export function MoveIcon() {
  return (
    <Svg>
      <rect x="3" y="5" width="11" height="13" rx="2" />
      <path d="M3 9h11M6.5 3v4M10.5 3v4" />
      <path d="M15 14.5h6M18 11.5l3 3-3 3" />
    </Svg>
  );
}

/** Сделать особым: карандаш. Правка одного занятия, а не всей серии. */
export function CustomIcon() {
  return (
    <Svg>
      <path d="M4 20h4L18 10a2.83 2.83 0 0 0-4-4L4 16z" />
      <path d="M13.5 6.5 17.5 10.5" />
    </Svg>
  );
}

/**
 * Отменить: перечёркнутый круг.
 *
 * ⚠️ Не корзина и не крестик. Корзина означала бы удаление, а занятие серии
 * никуда не удаляется, оно снимается; крестик в этой же карточке занят
 * закрытием, и две одинаковые фигуры рядом человек различать не обязан.
 */
export function CancelIcon() {
  return (
    <Svg>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M6 18 18 6" />
    </Svg>
  );
}

/** Вернуть занятие: стрелка назад по кругу. Действие чинит, а не рушит. */
export function RestoreIcon() {
  return (
    <Svg>
      <path d="M3 3v6h6" />
      <path d="M3.5 9a9 9 0 1 0 2.2-3.4L3 8" />
    </Svg>
  );
}

/** Закрыть карточку. Хром: с занятием не делает ничего. */
export function CloseIcon() {
  return (
    <Svg>
      <path d="M6 6 18 18M18 6 6 18" />
    </Svg>
  );
}
